import { useShepherd } from 'vue-shepherd'
import { offset, flip } from '@floating-ui/dom'

export const initTour = (customArgs = {}) => {
  const defaultArgs = {
    useModalOverlay: true,
    confirmCancel: () => {
      if (window.confirm('Would you like to exit the tutorial?')) {
        customArgs.onCancelCallback && customArgs.onCancelCallback()
        return true
      }
    },
    defaultStepOptions: {
      classes: 'motto-tour',
      modalOverlayOpeningRadius: 2,
      floatingUIOptions: {
        middleware: [flip(), offset(10)],
      },
      scrollTo: { behavior: 'smooth', block: 'center' },
      cancelIcon: { enabled: true },
      canClickTarget: false,
    },
  }
  return useShepherd({ ...defaultArgs, ...customArgs })
}
